import React, { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

/**
 * Estado vacío ilustrado: icono en círculo tintado + título + subtítulo opcional
 * + acción opcional. `compact` para cajas chicas (tarjetas del dashboard);
 * por defecto cómodo. Usa el token semántico `accent` (mode-aware).
 */
const EmptyState: React.FC<{
  icon: LucideIcon;
  title: string;
  subtitle?: string;
  action?: ReactNode;
  compact?: boolean;
  className?: string;
}> = ({ icon: Icon, title, subtitle, action, compact = false, className = '' }) => (
  <div
    className={`flex flex-col items-center justify-center text-center ${compact ? 'py-6' : 'py-12'} ${className}`}
  >
    <div
      className={`grid place-items-center rounded-full bg-accent/10 text-accent ring-1 ring-accent/20 ${compact ? 'h-12 w-12' : 'h-16 w-16'}`}
    >
      <Icon size={compact ? 22 : 30} strokeWidth={1.75} />
    </div>
    <p className={`mt-3 font-semibold text-content ${compact ? 'text-sm' : 'text-base'}`}>{title}</p>
    {subtitle && <p className="mt-1 max-w-xs text-xs text-content-3">{subtitle}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);

export default EmptyState;
